import { heroStats } from "@/mocks/kanliao";

export default function SiteFooter() {
  return (
    <>
      {/* CTA band */}
      <section className="bg-foreground-950">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 px-5 py-12 md:flex-row md:items-center md:px-8 md:py-14">
          <div>
            <span className="font-label text-xs font-semibold uppercase tracking-[0.24em] text-accent-400">
              别错过下一个猛料
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-background-50 md:text-3xl">
              下一个大瓜，别让你最后一个知道
            </h2>
            <p className="mt-2 max-w-lg text-sm leading-relaxed text-foreground-300">
              看料网持续滚动更新今日新料与全网吃瓜汇总，回来就能接上进度，随时掌握当前热点事件的最新走向。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <a
              href="#express"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-600"
            >
              <i className="ri-flashlight-fill" aria-hidden="true"></i>
              看新料速递
            </a>
            <a
              href="#today"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-200"
            >
              回今日热度榜
            </a>
          </div>
        </div>
      </section>

      {/* footer */}
      <footer className="bg-background-200 pt-12 pb-8">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <div className="flex flex-col gap-8 md:flex-row md:justify-between">
            <div className="max-w-sm">
              <div className="flex items-center gap-2.5">
                <span className="grid h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
                </span>
                <span className="font-heading text-xl font-black tracking-wide text-foreground-950">看料网</span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-secondary-700">
                看料网今日猛料、最新爆料合集、热门大瓜盘点与全网吃瓜汇总的每日速报站，帮你开页即掌握热点事件与吃瓜方向。
              </p>
            </div>

            <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
              <div>
                <h4 className="mb-3 text-sm font-bold text-foreground-950">内容栏目</h4>
                <ul className="space-y-2 text-sm text-secondary-700">
                  <li><a href="#today" className="hover:text-primary-700">今日热度榜</a></li>
                  <li><a href="#leaks" className="hover:text-primary-700">最新爆料合集</a></li>
                  <li><a href="#review" className="hover:text-primary-700">热门大瓜盘点</a></li>
                </ul>
              </div>
              <div>
                <h4 className="mb-3 text-sm font-bold text-foreground-950">更多内容</h4>
                <ul className="space-y-2 text-sm text-secondary-700">
                  <li><a href="#feed" className="hover:text-primary-700">全网吃瓜汇总</a></li>
                  <li><a href="#words" className="hover:text-primary-700">吃瓜热词风向</a></li>
                  <li><a href="#express" className="hover:text-primary-700">新料速递</a></li>
                </ul>
              </div>
              <div className="col-span-2 sm:col-span-1">
                <h4 className="mb-3 text-sm font-bold text-foreground-950">今日概况</h4>
                <ul className="space-y-2 text-sm text-secondary-700">
                  {heroStats.map((s) => (
                    <li key={s.label} className="flex items-center justify-between">
                      <span>{s.label}</span>
                      <span className="font-heading font-bold text-foreground-900">{s.value}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-10 border-t border-background-300 pt-5">
            <p className="text-xs leading-relaxed text-secondary-600">
              免责声明：本站内容整理自公开网络信息，仅供娱乐与信息聚合参考，不构成任何立场；文中人名均为化名，事件最终以各方官方回应为准。
            </p>
            <div className="mt-3 flex flex-col gap-1 text-xs text-secondary-500 sm:flex-row sm:items-center sm:justify-between">
              <span>© {new Date().getFullYear()} 看料网 KANLIAO · 今日猛料 / 最新爆料合集 / 热门大瓜盘点 / 全网吃瓜汇总 / 新料速递</span>
              <a href="#top" className="inline-flex items-center gap-1 hover:text-primary-700">
                <i className="ri-arrow-up-line" aria-hidden="true"></i>回到顶部
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}